import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var ConfirmDialogService = /** @class */ (function () {
    function ConfirmDialogService() {
        this._isOpen = false;
        this.isOpen = new BehaviorSubject(this._isOpen);
    }
    /**
     * Close confirm dialog
     */
    ConfirmDialogService.prototype.closeConfirmDialog = function () {
        this._isOpen = false;
        this.isOpen.next(this._isOpen);
    };
    /**
     * Opens confirm dialog
     */
    ConfirmDialogService.prototype.openConfirmDialog = function () {
        this._isOpen = true;
        this.isOpen.next(this._isOpen);
    };
    /**
     * Get if is open
     */
    ConfirmDialogService.prototype.getIsOpen = function () {
        return this._isOpen;
    };
    /**
     * Focus on confirm dialog
     */
    ConfirmDialogService.prototype.focusConfirmDialog = function () {
        var CONFIRM_DIALOG = document.getElementById('app-confirm-dialog');
        if (CONFIRM_DIALOG) {
            CONFIRM_DIALOG.focus();
        }
    };
    ConfirmDialogService.ngInjectableDef = i0.defineInjectable({ factory: function ConfirmDialogService_Factory() { return new ConfirmDialogService(); }, token: ConfirmDialogService, providedIn: "root" });
    return ConfirmDialogService;
}());
export { ConfirmDialogService };
